<template>
    <b-card no-body>
        <b-modal id="sessions" title="Saatler" hide-footer no-close-on-esc no-close-on-backdrop>
            <ul class="list-group">
                <li class="list-group-item" v-for="(s,i) in (sessions || [])">{{ s }}</li>
                <li class="list-group-item" v-if="(sessions || []).length == 0" >Henüz bir veri bulunmaktadır.</li>
            </ul>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    pagination="server"
                    :buttons="buttons"
                    :settings="false"
                    search
                    v-on:fetch-result-raw="onFetch">
                <template #additional-actions>
                    <div class="row">
                        <div class="col-md-auto mb-1 mb-md-0">
                            <select class="form-control bg-img-none" v-model="branchType">
                                <option value="O">Org. Şube</option>
                                <option value="S">SGK Şube</option> 
                            </select>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0" v-if="branchType == 'O'">
                            <v-select-list :options="branches" label="Name" v-model="branch" placeholder="Tüm Org. Şubeler"></v-select-list>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0" v-if="branchType == 'S'">
                            <v-select-list :options="sbranches" label="Name" v-model="sbranch" placeholder="Tüm SGK Şubeler"></v-select-list>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0">
                            <v-select-list :options="collarStatuses" label="Name" v-model="collarStatus" placeholder="Tüm Yakalar"></v-select-list>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0">
                            <v-select-list :options="statuses" label="name" v-model="status" placeholder="Kritiklik Seviyesi"></v-select-list>
                        </div>
                        <div class="col-md-2 mb-1 mb-md-0">
                            <v-select-list :options="educations" label="Name" v-model="education" placeholder="Eğitim"></v-select-list>
                        </div>
                        <div class="col-md-1">
                            <select class="form-control bg-img-none" v-model="jobExit">
                                <option :value="null">Tümü</option>
                                <option :value="false">Çalışıyor</option>
                                <option :value="true">Ayrıldı</option>
                            </select>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-success" v-on:click="$refs.table.refresh()">Sorgula</button>
                        </div>
                        <div class="col-auto" v-if="excelPath">
                            <button class="btn btn-outline-success" v-on:click="downloadExcel">Excel</button>
                        </div>
                    </div>
                </template>
                </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import OHSEducationApi from '@/api/ohs-education'
import moment from 'moment'
import CompanyApi from '@/api/company'
import SystemDataApi from '@/api/system-data'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard
    },
    data(){
        return {
            fields:[
                {tdClass:'text-nowrap',name:'Personel',key:'EmployeeFullName',thClass:'w-10'},
                {tdClass:'text-nowrap',name:'SGK Şube',key:'SGKBranchName',thClass:'w-10'},
                {tdClass:'text-nowrap',name:'Unvan',key:'EmployeeDepartmentTitleName',thClass:'w-10'},
                {tdClass:'text-nowrap',name:'Yaka',key:'CollarStatusName',thClass:'w-10'},
                {tdClass:'text-nowrap',name:'Meslek Kodu',key:'OccupationTitleCode',thClass:'w-10'},
                {tdClass:'text-nowrap',name:'Eğitim ',key:'EducationName',thClass:'w-10'},
                {tdClass:'text-nowrap',name:'Başlangıç Tarihi',key:'ValidityStartDateStr',thClass:'w-10'},
                {tdClass:'text-nowrap',name:'Kalan Eğitim Saati',key:'TimeDifference',thClass:'w-10'},
                {tdClass:'text-nowrap',name:'Bitiş Tarihi',key:'ValidityEndDateStr',thClass:'w-10'},
                {tdClass:'text-nowrap',name:'Kalan Gün',key:'RemainingDate',thClass:'w-10'},
                {name:"Kritiklik Seviyesi", component:true,componentOptions:{name:"employee-report-status/EmployeeReportStatus"}},
            ],
            buttons:[
                { text:"Saatler",key:"edit",icon:"ClockIcon",variant:"primary",action:this.showSessions},
                { text:"İndir",key:"download",icon:"DownloadIcon",variant:"secondary",action:this.download},
            ],
            branches:[],
            sbranches:[],
            collarStatuses:[],
            branchType:'O',
            branch:null,
            sbranch:null,
            collarStatus:null,
            excelPath:null,
            jobExit:null,
            statuses:[
                {name:'Devam Ediyor',key:'DE'},
                {name:'Yaklaşıyor',key:'Y'},
                {name:'Dolmak Üzere',key:'DU'},
                {name:'Bitti',key:'B'},
            ],
            status:null,
            educations:[],
            education:null,
        }
    },
    mounted(){
        this.getSBranches()
        this.getBranches()
        this.getCollarStatuses()
        this.getEducations()
    },
    methods:{
        onFetch(e){
            this.excelPath = e.data.ExcelPath
        },
        provider(data){
            return OHSEducationApi.Employee.Report({
                PaginateRequest: data,
                Month:moment().month() + 1,
                Year:moment().year(),
                JobExit:this.jobExit,
                BranchId: this.branchType == 'O' ? (this.branch?.Id || null) : (this.sbranch?.Id || null),
                BranchTypeCode: this.branchType,
                CollarStatusId: this.collarStatus?.Id || null,
                Status: this.status?.key || null,
                OHSEducationId: this.education?.Id || null
            })
        },
        getBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.branches = res.data.Data
            })
        },
        getSBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sbranches = res.data.Data
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
        getEducations(){
            OHSEducationApi.List().then(res => {
                this.educations = res.data.Data
            })
        },
        downloadExcel(){
            if(this.excelPath){
                Additional.DownloadTab(this.excelPath)
            }
        },
        showSessions(i){
            this.sessions = i.Sessions || []
            this.$showModal('sessions')
        },
        download(i){
            if(i.FilePath){
                Additional.DownloadTab(i.FilePath)
            }
        }
    }
}
</script>